import { modalModel } from 'entities/modal';
import { createAppAsyncThunk, ERC_20_ABI, logger } from 'shared';
import { wagmiConfig } from 'shared/config/wagmi';
import { citCrowdsaleContract, wusdtContract } from 'shared/config/wallet-service/contracts';
import { Address } from 'viem';
import { getAccount, readContract, waitForTransactionReceipt, writeContract } from 'wagmi/actions';

type ApproveArgs = {
  amount: bigint;
};

// TODO: remove duplicate approve thunks, make one shared for all crowdsales
export const approve = createAppAsyncThunk(
  'citCrowdsale/approve',
  async ({ amount }: ApproveArgs, { rejectWithValue, dispatch }) => {
    const { address } = getAccount(wagmiConfig);

    if (!address) {
      throw new Error('Empty provider');
    }

    dispatch(
      modalModel.actions.openModal({
        type: modalModel.ModalType.Approve,
        transition: 'fade',
      }),
    );

    const allowance = await readContract(wagmiConfig, {
      abi: ERC_20_ABI,
      address: wusdtContract.address as Address,
      functionName: 'allowance',
      args: [address, citCrowdsaleContract.address],
    });

    if (allowance >= amount) return true;

    try {
      const approveTxHash = await writeContract(wagmiConfig, {
        abi: ERC_20_ABI,
        address: wusdtContract.address as Address,
        functionName: 'approve',
        args: [citCrowdsaleContract.address, amount],
      });

      const approveResult = await waitForTransactionReceipt(wagmiConfig, { hash: approveTxHash });

      if (approveResult.status !== 'success') {
        throw new Error('Failed to approve');
      }
    } catch (err) {
      dispatch(
        modalModel.actions.openModal({
          type: modalModel.ModalType.ApproveReject,
          data: {
            onRetry: () => {
              dispatch(approve({ amount }));
            },
          },
          transition: 'fade',
        }),
      );
      logger('citCrowdsale/approve', err);
      return rejectWithValue(err);
    }

    return true;
  },
);
